import React, { PureComponent } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import MenuLinksSortable from './headerContentView/menuLinksSortable';

class HeaderContentView extends PureComponent {
  render () {
    const {
      items,
      logoImage,
      onClickEdit,
      onChangeLinksList,
      myFiuURL,
      menuColor
    } = this.props;

    return (
      <div>
        <Row className="image-bg">
          <Col sm={8}>
            <div className="text-right">
              <div className="edit-link">
                <span
                  onClick={onClickEdit}
                >
                  Edit
                </span>
              </div>
            </div>
            <h2 className="image-bg-title">Logo</h2>
            <img
              className="header-image-logo"
              src={logoImage}
              alt=""
            />
          </Col>
        </Row>
        <Row className="header-menu-links image-bg">
          <Col sm={8}>
            <h2 className="image-bg-title">MyFIU URL</h2>
            <a href={myFiuURL} target="_blank" rel="noopener noreferrer">
              {myFiuURL}
            </a>
          </Col>
        </Row>
        <Row className="header-menu-links image-bg">
          <Col sm={8}>
          <h2 className="image-bg-title">Menu color</h2>
            <div className="edit-menu-options">
              <span className={`edit-menu-blue ${menuColor === 'colorDark' ? 'active' : ''}`}></span>
              <span className={`edit-menu-white ${menuColor === 'colorLight' ? 'active' : ''}`}></span>
            </div>
          </Col>
        </Row>
        <Row className="header-menu-links image-bg">
          <Col sm={8}>
            <h2 className="image-bg-title">Menus</h2>
            <MenuLinksSortable
              linksList={items}
              onChangeLinksList={onChangeLinksList}
            />
          </Col>
        </Row>
      </div>
    );
  }
}

HeaderContentView.propTypes = {
  logoImage: PropTypes.string,
  items: PropTypes.array,
  onClickEdit: PropTypes.func,
  onChangeLinksList: PropTypes.func,
}

export default HeaderContentView;



// WEBPACK FOOTER //
// ./src/app/screens/general/headerContent/headerContentView.js